/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Quick_Add_LabelInputs */

const en_quick_add_label = /** @type {(inputs: Quick_Add_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Add item`)
};

const de_quick_add_label = /** @type {(inputs: Quick_Add_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Artikel hinzufügen`)
};

/**
* | output |
* | --- |
* | "Add item" |
*
* @param {Quick_Add_LabelInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const quick_add_label = /** @type {((inputs?: Quick_Add_LabelInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Quick_Add_LabelInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_quick_add_label(inputs)
	return en_quick_add_label(inputs)
});